import {HttpClient}                 from "@angular/common/http";
import {Injectable}                 from '@angular/core';

import {AngularQuery}               from "../query/angularquery";

import {Observable}                 from "rxjs/Observable";
import {Version}                    from "./version";

@Injectable()
export class VersionService {

	/**
	 * Initialize the HttpClient object.
	 * @param {HttpClient} http
	 */
	constructor(

		protected http: HttpClient,

	) {}


	/**
	 * Get the versions for a specific article.
	 *
	 * @param {number} id  The ID of the 'news' table item to get versions for.
	 * @return {Observable<Version[]>} An array of Version items.
	 */
	getVersions(id:number): Observable<Version[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_VERSION, String(id));
		query.useParams(false);

		return this.http.get<Version[]>(query.getUrl());

	}

}



// WEBPACK FOOTER //
// ./src/app/services/version/version.service.ts